export default __webpack_public_path__ + "static/media/splashCenter.bf8c3d92.svg";